<h2 mat-dialog-title>Are you sure?</h2>
<mat-dialog-content>
  <p>Do you want to delete this item?</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button color="warn" (click)="onConfirm()">Delete</button>
</mat-dialog-actions>